import { useCallback, useState, useEffect } from 'react';
export function useScrollTrigger(scrollResetTime = 500) {
    const [hasStartedScrolling, setHasStartedScrolling] = useState(false);
    const handleScroll = useCallback(() => {
        if (!hasStartedScrolling) {
            setHasStartedScrolling(true);
        }
    }, [hasStartedScrolling]);
    useEffect(() => {
        if (hasStartedScrolling) {
            const timer = setTimeout(() => {
                setHasStartedScrolling(false);
            }, scrollResetTime);
            return () => clearTimeout(timer);
        }
        return undefined;
    }, [hasStartedScrolling, scrollResetTime]);
    return {
        handleScroll,
        hasStartedScrolling,
    };
}
